import React, { useEffect, useState } from "react";

import PostItem from "./components/PostItem/PostItem";
import { AnimationFileLoader } from "../../../utilis/animation-loader"; // Adjust the path
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllBlogs } from "../../../redux/actions/project";
import Footer from "../../../shared-components/Footer/Footer";
import { getAllCategories } from "../../../redux/actions/category";
//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />

function Blog() {
  const dispatch = useDispatch();
  const { error, blogs, message } = useSelector((state) => state.blog);
  const { categories } = useSelector((state) => state.category);
  const [selectedCollection, setSelectedCollection] = useState("");

  AnimationFileLoader();

  useEffect(() => {
    if (error) {
      dispatch({ type: "clearError" });
    }
    if (message) {
      dispatch({ type: "clearMessage" });
    }

    dispatch(getAllBlogs(selectedCollection));
    dispatch(getAllCategories());
  }, [error, message, dispatch, selectedCollection]);


  return (
    <>
      {/* Author */}
      <div className="author-area">
        <div
          className="author-cover"
          data-bg-img="/img/bg/author-cover.png"
        ></div>
      </div>
      {/* End Author */}
      {/* Blog */}
      <section className="pt-120 pb-120">
        <div className="container">

          <div className="filter-options d-flex flex-wrap justify-content-center justify-content-lg-start mb-4">
            <select
              className="select-rounded mb-10 lg me-4"
              value={selectedCollection}
              onChange={(e) => setSelectedCollection(e.target.value)}
            >
              <option value="">All Collections</option>
              {categories?.map((item, index) => (
                <option key={index} value={item?.category}>
                  {item?.category}
                </option>
              ))}
            </select>

          </div>
          <div className="row">
            {/* <div className="col-xl-4 col-md-6"> */}
            {/* Single Post Item */}

            {/* End Single Post Item */}
            {/* </div> */}
            {blogs?.map((blog) => (
              <div className="col-xl-6 col-md-6">
                {/* Single Post Item */}
                <PostItem
                  link={`/blogs/${blog?._id}`}
                  category={blog?.category?.category}
                  productImgSrc={blog?.image?.url}
                  title={blog?.title}
                  description={blog?.shortDescription?.slice(0, 150)}
                  authorName={blog?.author}
                  date={blog?.createdAt?.slice(0, 10)}
                />

                {/* End Single Post Item */}
              </div>
            ))}
            {/* <div className="col-lg-12 d-flex justify-content-center mt-30">
              <NavLink to="#" className="btn">
                <img src="/img/icons/btn-loadmore.svg" alt="" className="svg" />
                Load More
              </NavLink>
            </div> */}
          </div>
        </div>
      </section>
      {/* End Blog */}

      {/* Instafeed */}
      {/* <div className="insta_feed mt-n2 mb-2 ovx-hidden">
        <NavLink to="https://www.instagram.com/" className="btn">
          <img src="/img/icons/btn-instagram.svg" alt="" className="svg" />
          instagram
        </NavLink>
        <ul className="row g-2">
          <li className="col-lg col-sm-4 col-6">
            <NavLink to="https://www.instagram.com/" className="d-block">
              <img src="/img/media/insta1.png" alt="" />
            </NavLink>
          </li>
          <li className="col-lg col-sm-4 col-6">
            <NavLink to="https://www.instagram.com/" className="d-block">
              <img src="/img/media/insta2.png" alt="" />
            </NavLink>
          </li>
          <li className="col-lg col-sm-4 col-6">
            <NavLink to="https://www.instagram.com/" className="d-block">
              <img src="/img/media/insta3.png" alt="" />
            </NavLink>
          </li>
          <li className="col-lg col-sm-4 col-6">
            <NavLink to="https://www.instagram.com/" className="d-block">
              <img src="/img/media/insta4.png" alt="" />
            </NavLink>
          </li>
          <li className="col-lg col-sm-4 col-6">
            <NavLink to="https://www.instagram.com/" className="d-block">
              <img src="/img/media/insta5.png" alt="" />
            </NavLink>
          </li>
          <li className="col-lg col-sm-4 col-6">
            <NavLink to="https://www.instagram.com/" className="d-block">
              <img src="/img/media/insta6.png" alt="" />
            </NavLink>
          </li>
        </ul>
      </div> */}
      {/* End Instafeed */}
      <Footer />
    </>
  );
}

export default Blog;
